import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import { Dotdotdot, SelectableList } from 'components';
import ContentSearchResultIdea from './ContentSearchResultIdea';
import LinkDefaultIcon from 'material-ui/svg-icons/action/description';
import * as styles from './ContentSearchResults.scss';
import marked from 'marked';
import _ from 'lodash';
var renderer = new marked.Renderer();

renderer.paragraph = function (text) {
  return text;
};

var ContentSearchResults = /*#__PURE__*/function (_Component) {
  _inherits(ContentSearchResults, _Component);

  var _super = _createSuper(ContentSearchResults);

  function ContentSearchResults(props) {
    var _this;

    _classCallCheck(this, ContentSearchResults);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "highlightSearchQuery", function (str) {
      var searchQuery = _this.props.searchQuery;

      if (searchQuery) {
        var modStr = "".concat(str);
        var re = new RegExp("(".concat(searchQuery, ")"), 'gmi');
        return modStr.replace(re, function (match) {
          return "**".concat(match, "**");
        });
      }

      return str;
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (_this.state.activeIdea) {
        if (e.keyCode === 38) {
          e.preventDefault(); // up arrow

          _this.moveSelectedListIndex(-1);
        } else if (e.keyCode === 40) {
          e.preventDefault(); // down arrow

          _this.moveSelectedListIndex(1);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "moveSelectedListIndex", function (modifier) {
      var results = _this.props.results;
      var showFavoritesColumn = !_this.state.activeIdea || _this.state.activeIdea && _this.state.activeIdeaType === 'favorites';
      var showOtherColumn = !_this.state.activeIdea || _this.state.activeIdea && _this.state.activeIdeaType === 'other';
      var list = [];

      if (showFavoritesColumn && !showOtherColumn && results.ideasInFavorites && results.ideasInFavorites.length > 0) {
        list = _toConsumableArray(results.ideasInFavorites);
      } else if (!showFavoritesColumn && showOtherColumn && results.otherIdeas && results.otherIdeas.length > 0) {
        list = _toConsumableArray(results.otherIdeas);
      }

      if (list && list.length > 0) {
        var curIdx = list.findIndex(function (i) {
          return "".concat(i.id) === "".concat(_this.state.activeIdea.id);
        });

        if (curIdx > -1) {
          var selectedIdx = curIdx + modifier;
          var selected = list[selectedIdx];

          if (selected) {
            _this.setState({
              activeIdea: selected
            });

            if (showOtherColumn) {
              _this.attemptToCenterScroll(_this.otherColumnRef, selectedIdx);
            } else if (showFavoritesColumn) {
              _this.attemptToCenterScroll(_this.favColumnRef, selectedIdx);
            }
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "attemptToCenterScroll", function (ref, selectedIdx) {
      try {
        var element = ref._reactInternalInstance._hostParent._hostNode.firstChild;
        element.scrollTop = _.clamp((selectedIdx - 3) * 72, 0, element.scrollTopMax);
      } catch (e) {
        console.error(e);
      }
    });

    _this.state = {
      activeIdea: null,
      activeIdeaType: ''
    };
    return _this;
  }

  _createClass(ContentSearchResults, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          clearCurrentSearch = _this$props.clearCurrentSearch,
          results = _this$props.results,
          orgId = _this$props.orgId;
      var showFavoritesColumn = !this.state.activeIdea || this.state.activeIdea && this.state.activeIdeaType === 'favorites';
      var showOtherColumn = !this.state.activeIdea || this.state.activeIdea && this.state.activeIdeaType === 'other';
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, !this.state.activeIdea && /*#__PURE__*/React.createElement(List, {
        style: {
          flex: '0 0 26%',
          maxWidth: '26%',
          padding: 0,
          maxHeight: 792
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.columnTitle
      }, /*#__PURE__*/React.createElement("div", null, "Categories")), results && results.categories && !!results.categories.length ? results.categories.map(function (cat) {
        return /*#__PURE__*/React.createElement(ListItem, {
          primaryText: /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: marked(_this2.highlightSearchQuery(cat.tagName), {
                renderer: renderer
              })
            }
          }),
          leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
            src: cat.avatarImageUrl
          }),
          onClick: function onClick() {
            clearCurrentSearch(orgId);
            browserHistory.push("/org/".concat(orgId, "/content/category/").concat(cat.slug));
          }
        });
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 12
        }
      }, "No matches for your search.")), showFavoritesColumn && /*#__PURE__*/React.createElement(SelectableList, {
        ref: function ref(r) {
          return _this2.favColumnRef = r;
        },
        value: this.state.activeIdea ? this.state.activeIdea.id : -1,
        onChange: function onChange() {},
        style: this.state.activeIdea ? {
          flex: '0 0 37%',
          maxWidth: '37%',
          padding: 0,
          maxHeight: 1000,
          overflowY: 'scroll'
        } : {
          borderLeft: '1px solid #f1f1f1',
          flex: '0 0 37%',
          maxWidth: '37%',
          minWidth: '37%',
          padding: 0,
          maxHeight: 792,
          overflowY: 'scroll'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.columnTitle
      }, /*#__PURE__*/React.createElement("div", null, "Favorite Ideas")), results && results.ideasInFavorites && !!results.ideasInFavorites.length ? results.ideasInFavorites.map(function (favIdea) {
        return /*#__PURE__*/React.createElement(ListItem, {
          value: favIdea.id,
          leftAvatar: !!favIdea.PostTemplateS3Files.length && favIdea.PostTemplateS3Files[0].S3File ? /*#__PURE__*/React.createElement(Avatar, {
            src: favIdea.PostTemplateS3Files[0].S3File.fullyQualifiedUrl
          }) : /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(LinkDefaultIcon, null)),
          primaryText: /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: marked(_this2.highlightSearchQuery(favIdea.title), {
                renderer: renderer
              })
            }
          }),
          secondaryText: /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: marked(_this2.highlightSearchQuery(favIdea.message), {
                renderer: renderer
              })
            }
          })),
          onClick: function onClick() {
            _this2.setState({
              activeIdea: favIdea,
              activeIdeaType: 'favorites'
            });
          }
        });
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 12
        }
      }, "No favorite ideas match your search.")), showOtherColumn && /*#__PURE__*/React.createElement(SelectableList, {
        ref: function ref(r) {
          return _this2.otherColumnRef = r;
        },
        className: styles.column,
        value: this.state.activeIdea ? this.state.activeIdea.id : -1,
        onChange: function onChange() {},
        style: this.state.activeIdea ? {
          flex: '0 0 37%',
          maxWidth: '37%',
          padding: 0,
          maxHeight: 1000,
          overflowY: 'scroll'
        } : {
          borderLeft: '1px solid #f1f1f1',
          flex: '0 0 37%',
          maxWidth: '37%',
          padding: 0,
          maxHeight: 792,
          overflowY: 'scroll'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.columnTitle
      }, /*#__PURE__*/React.createElement("div", null, "All Ideas")), results && results.otherIdeas && !!results.otherIdeas.length ? results.otherIdeas.map(function (otherIdea) {
        return /*#__PURE__*/React.createElement(ListItem, {
          id: "test-searchresultrow_".concat(otherIdea.id),
          value: otherIdea.id,
          leftAvatar: !!otherIdea.PostTemplateS3Files.length && otherIdea.PostTemplateS3Files[0].S3File ? /*#__PURE__*/React.createElement(Avatar, {
            src: otherIdea.PostTemplateS3Files[0].S3File.fullyQualifiedUrl
          }) : /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(LinkDefaultIcon, null)),
          primaryText: /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: marked(_this2.highlightSearchQuery(otherIdea.title), {
                renderer: renderer
              })
            }
          }),
          secondaryText: /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: marked(_this2.highlightSearchQuery(otherIdea.message), {
                renderer: renderer
              })
            }
          })),
          onClick: function onClick() {
            _this2.setState({
              activeIdea: otherIdea,
              activeIdeaType: 'other'
            });
          }
        });
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 12
        }
      }, "No ideas match your search.")), this.state.activeIdea && /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 63%',
          maxWidth: '63%',
          padding: 0,
          borderLeft: '1px solid #f1f1f1'
        }
      }, /*#__PURE__*/React.createElement(ContentSearchResultIdea, {
        clearCurrentSearch: clearCurrentSearch,
        orgId: orgId,
        idea: this.state.activeIdea,
        handleBackToResults: function handleBackToResults() {
          _this2.setState({
            activeIdea: null,
            activeIdeaType: ''
          });
        }
      })));
    }
  }]);

  return ContentSearchResults;
}(Component);

export default ContentSearchResults;